import { render, staticRenderFns } from "./radio-transfer.vue?vue&type=template&id=c28853c0"
import script from "./radio-transfer.vue?vue&type=script&lang=js"
export * from "./radio-transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports